import React, { Component } from 'react';
import { Chart } from 'primereact/chart';
import { SelectButton } from 'primereact/selectbutton';
import { UtilService } from 'hay-core-react';
import DashboardAjuda from './DashboardAjuda';

const CHAVE_OUTROS = 'main.dashboard.grafico.outros';
const COR_OUTROS = '#9CA3AF';
const PALETA = ['#3B82F6', '#22C55E', '#F97316', '#A855F7', '#EC4899', '#06B6D4', '#EAB308'];

const OPCOES_TIPO = [
  { icon: 'pi pi-chart-pie', value: 'doughnut' },
  { icon: 'pi pi-bars', value: 'bar' },
];

// Gráfico pizza/barra genérico de distribuição categórica — espelho de
// hay-hotspot/assets/reactweb/src/pages/Auth/Dashboard/DashboardGraficoPizza.js, sem mudanças
// (mesmo componente serve qualquer breakdown chave/quantidade).
class DashboardGraficoPizza extends Component {
  state = { tipo: 'doughnut' };

  render() {
    const { titulo, itens, help } = this.props;
    const { tipo } = this.state;

    const seletor = (
      <SelectButton
        value={tipo}
        onChange={(e) => e.value && this.setState({ tipo: e.value })}
        options={OPCOES_TIPO}
        optionValue="value"
        itemTemplate={(opt) => <i className={opt.icon} />}
      />
    );

    if (!itens || itens.length === 0) {
      return (
        <div className="surface-card shadow-2 border-round p-3 h-full">
          <div className="flex justify-content-between align-items-center mb-3">
            <div className="text-lg font-medium">{titulo}<DashboardAjuda texto={help} /></div>
            {seletor}
          </div>
          <div className="text-color-secondary text-center p-4">
            {UtilService.traduzir('main.dashboard.grafico.semdados')}
          </div>
        </div>
      );
    }

    let corIndice = 0;
    const cores = itens.map((item) => {
      if (item.chave === CHAVE_OUTROS) return COR_OUTROS;
      const cor = PALETA[corIndice % PALETA.length];
      corIndice += 1;
      return cor;
    });

    const data = {
      labels: itens.map((item) => UtilService.traduzir(item.chave)),
      datasets: [{
        data: itens.map((item) => item.quantidade),
        backgroundColor: cores,
        hoverBackgroundColor: cores,
      }],
    };

    const options = tipo === 'bar' ? {
      indexAxis: 'y',
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
      },
      scales: {
        x: { beginAtZero: true, ticks: { precision: 0 } },
        y: { ticks: { autoSkip: false, font: { size: 10 } } },
      },
    } : {
      maintainAspectRatio: false,
      plugins: {
        legend: { position: 'bottom' },
      },
    };

    return (
      <div className="surface-card shadow-2 border-round p-3 h-full" style={{ minWidth: 0 }}>
        <div className="flex justify-content-between align-items-center mb-3">
          <div className="text-lg font-medium">{titulo}<DashboardAjuda texto={help} /></div>
          {seletor}
        </div>
        <Chart type={tipo} data={data} options={options} style={{ width: '100%', height: '220px' }} />
      </div>
    );
  }
}

export default DashboardGraficoPizza;
